'use client';

import { useEffect } from 'react';

/**
 * Registers the service worker so next-pwa can cache static JS/CSS (StaleWhileRevalidate).
 * next-pwa generates sw.js at build time; we register it here because register: false in next.config
 * (App Router does not auto-register). Only mount this component when PWA_SERVICE_WORKER_ENABLED is true.
 */
export default function PwaRegister() {
  useEffect(() => {
    // Guard: service workers only exist in the browser and when the API is supported.
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';
    const swPath = `${basePath}/sw.js`;
    navigator.serviceWorker.register(swPath, {
      scope: basePath || '/'
    }).then(() => {
      // Registration succeeded; next-pwa will handle caching. No console output in production.
    }).catch(() => {
      // Registration can fail (e.g. not HTTPS, wrong scope, sw.js 404). Fail silently so the app still works.
    });
  }, []);
  return null;
}